/*
==================================================
 INFINITE-CAROUSEL.JS
==================================================
*/

class InfiniteCarousel {
  constructor(props) {
    this.slider;
    this.sliderItems;
    this.posX1;
    this.posX2;
    this.posInitial;
    this.posFinal;
    this.threshold;
    this.slides;
    this.slidesLength;
    this.slideSize;
    this.firstSlide;
    this.lastSlide;
    this.cloneFirst;
    this.cloneLast;
    this.allowShift;
    this.autoPlay;
    this.sliderInterval;
    this.indicatorDots;
    this.currentIndicator;
    this.index;
    this.pausePlayButton;
    this.pausePlay;
    this.isPlaying;
    this.lazyLoad;
    this.pausePlaySpaceBar;
  }

  init(opts) {
    this.slider = opts.carouselContainer;
    this.autoPlay = opts.autoPlay;
    this.indicatorDots = opts.indicatorDots;
    this.sliderItems = this.slider.querySelector('.carousel-infinite-slides');
    this.posX1 = 0;
    this.posX2 = 0;
    this.posInitial;
    this.posFinal;
    this.threshold = 100;
    this.slides = this.sliderItems.querySelectorAll('.carousel-infinite-slide');
    this.slidesLength = this.slides.length;
    this.slideSize;
    this.firstSlide = this.slides[0];
    this.lastSlide = this.slides[this.slidesLength - 1];
    this.cloneFirst = this.firstSlide.cloneNode(true);
    this.cloneLast = this.lastSlide.cloneNode(true);
    this.index = 0;
    this.allowShift = true;
    this.currentIndicator = 1;
    this.TIME_INTERVAL = opts.interval || 3000; // ms
    this.pausePlayButton = this.slider.parentNode.querySelector('.pause-play');
    this.pausePlay = opts.pausePlay;
    this.isPlaying = true;
    this.lazyLoad = opts.lazyLoad;
    this.pausePlaySpaceBar = opts.pausePlaySpaceBar;

    /*
    ==================================================
    WIRE DOM ELEMENTS
    ==================================================
    */

    window.addEventListener('load', (e) => {
      this.handleLoadAction(e);
    });

    window.addEventListener('resize', () => {
      this.handleResizeAction();
    });

    if (this.pausePlay) {
      this.pausePlayButton.addEventListener('click', (e) => {
        this.handlePausePlayClick(e);
      });
    }

    if (this.pausePlaySpaceBar) {
      this.handlePausePlayOnSpaceBarPress();
    }

    // Transition event
    this.sliderItems.addEventListener('transitionend', (e) => {
      this.handleCheckIndex(e);
    });

  }

  /*
  ==================================================
  EVENT HANDLERS
  ==================================================
  */

  handleLoadAction(e) {
    e.preventDefault();
    this.setVisibleSlideOnLoad();
    this.cloneSlides();
    this.setActiveSlide();

    if (this.autoPlay) {
      this.startAutoSlide();
    }
    
    if (this.indicatorDots) {
      this.setIndicatorDotListener();
      this.setActiveIndicatorDot();
    }

    if (this.lazyLoad) {
      this.lazyLoadImages();
    }
  }

  handleResizeAction() {
    this.setVisibleSlideOnScreenResize();
  }

  handleCheckIndex(e) {
    e.stopPropagation();
    this.checkIndex();
  }

  handlePausePlayClick() {
    this.pausePlayCarousel();
  }

  handlePausePlayOnSpaceBarPress() {
    let handleKeyDownFunction = this.handleSpaceKeyDown.bind(this);

    this.slider.addEventListener('mouseenter', (e) => {
      document.addEventListener('keydown', handleKeyDownFunction);
    });

    this.slider.addEventListener('mouseleave', (e) => {
      document.removeEventListener('keydown', handleKeyDownFunction);
    });
  }

  /*
  ==================================================
  LOCAL UTILS
  ==================================================
  */

  setVisibleSlideOnLoad() {
    this.slideSize = this.sliderItems.getElementsByClassName('carousel-infinite-slide')[0].offsetWidth;
    this.sliderItems.style.left = -(this.slideSize) + 'px';
  }

  setVisibleSlideOnScreenResize() {
    this.slideSize = this.sliderItems.getElementsByClassName('carousel-infinite-slide')[0].offsetWidth;
    
    this.slides.forEach((slide) => {
      if (slide.classList.contains('active')) {
        let dataSlide = slide.getAttribute('data-slide');
        this.sliderItems.style.left = (-(this.slideSize) * dataSlide) + 'px';
      }
    });
  }

  cloneSlides() {
    if (this.sliderItems) {
      this.sliderItems.appendChild(this.cloneFirst);
      this.sliderItems.insertBefore(this.cloneLast, this.firstSlide);
    }
    this.identifyClone();
  }

  identifyClone() {
    let firstChild = this.sliderItems.firstElementChild;
    let lastChild = this.sliderItems.lastElementChild;

    firstChild.classList.add('clone-slide');
    lastChild.classList.add('clone-slide');
  }

  shiftSlide(dir, action) {
    this.sliderItems.classList.add('shifting');

    if (this.allowShift) {
      if (!action) { this.posInitial = this.sliderItems.offsetLeft; }

      if (dir == -1) {
        this.sliderItems.style.left = (this.posInitial + this.slideSize) + 'px';
        this.index--;
      } else if (dir == 1) {
        this.sliderItems.style.left = (this.posInitial - this.slideSize) + 'px';
        this.index++;
      }
    };

    if (this.autoPlay && this.isPlaying) {
      clearInterval(this.sliderInterval);
      this.startAutoSlide();
    }
    this.setActiveSlide();
    this.allowShift = false;
  }

  checkIndex() {
    this.sliderItems.classList.remove('shifting');

    if (this.index == -1) {
      this.sliderItems.style.left = -(this.slidesLength * this.slideSize) + 'px';
      this.index = this.slidesLength - 1;
    }

    if (this.index == this.slidesLength) {
      this.sliderItems.style.left = -(1 * this.slideSize) + 'px';
      this.index = 0;
    }
    this.allowShift = true;
    this.setActiveSlide(this.index);
  }

  startAutoSlide() {
    this.sliderInterval = setInterval(() => {
      this.shiftSlide(1);
    }, this.TIME_INTERVAL);

    if (this.indicatorDots) {
      this.setActiveIndicatorDot();
    }
  }

  setActiveSlide() {
    this.slides[0].classList.add('active');

    this.slides.forEach((slide) => {
      if (slide.classList.contains('active')) {
        slide.classList.remove('active');
      }
    });

    this.slides.forEach((slide, i) => {
      if (i == this.index) {
        slide.classList.add('active');
      }
    });
  }

  setActiveIndicatorDot(elem) {
    let indicator = document.querySelectorAll('.indicator');

    if (elem) {
      this.slides.forEach((slide) => {
        if (slide.getAttribute('data-slide') == elem) {
          slide.classList.add('active');
        } else {
          slide.classList.remove('active');
        }
      });
    }

    else {
      indicator.forEach((indicator) => {
        if (indicator.getAttribute('data-slide') == this.index + 1) {
          indicator.classList.add('active');
        } else {
          indicator.classList.remove('active');
        }
      });
    }

    if (this.index >= indicator.length) {
      indicator[0].classList.add('active');
    }
  }

  setIndicatorDotListener() {
    let indicator = document.querySelectorAll('.indicator');

    indicator.forEach((indicator) => {
      indicator.addEventListener('click', (e) => {
        let dataSlide = indicator.getAttribute('data-slide');
        this.sliderItems.style.left = (-(this.slideSize) * dataSlide) + 'px';
        this.index = dataSlide - 1;
        this.setActiveIndicatorDot(dataSlide);

        if (this.autoPlay && this.isPlaying) {
          clearInterval(this.sliderInterval);
          this.startAutoSlide();
        }
      });
    });
  }

  pausePlayCarousel() {
    if (this.isPlaying) {
      this.pauseCarousel();
    } else {
      this.playCarousel();
    }
  }

  handleSpaceKeyDown(e) {
    if (e.code == 'Space') {
      e.preventDefault();
      this.pausePlayCarousel();
    }
  }

  pauseCarousel() {
    this.isPlaying = false;

    if (this.pausePlayButton) {
      if (this.pausePlayButton.classList.contains('play')) {
        this.pausePlayButton.classList.remove('play');
        this.pausePlayButton.classList.add('pause');
      } else {
        this.pausePlayButton.classList.add('pause');
      }
    }

    clearInterval(this.sliderInterval);
  }

  playCarousel() {
    this.isPlaying = true;

    if (this.pausePlayButton) {
      if (this.pausePlayButton.classList.contains('pause')) {
        this.pausePlayButton.classList.remove('pause');
        this.pausePlayButton.classList.add('play');
      } else {
        this.pausePlayButton.classList.add('play');
      }
    }

    this.shiftSlide(1);
    clearInterval(this.sliderInterval);
    this.startAutoSlide();
  }

  lazyLoadImages() {
    let lazyLoadElements = this.slider.querySelectorAll('.custom-lazy-load');

    if ('IntersectionObserver' in window) {
      let imageObserver = new IntersectionObserver(function (entries, imageObserver) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            let image = entry.target;
            image.classList.remove('custom-lazy-load');
            imageObserver.unobserve(image);
          }
        });
      });

      lazyLoadElements.forEach(function (image) {
        imageObserver.observe(image);
      });
    } else {
      lazyLoadElements.forEach(function (image) {
        if (image.classList.contains('custom-lazy-load')) {
          image.classList.remove('custom-lazy-load')
        }
      });
    }
  }
}

export default InfiniteCarousel;

